export default __webpack_public_path__ + "images/926e2df1a1346642ff096f67fd29896f.png";